import { IconContent } from '@icons';

export const viceVersaCaretsVerticalFilled: IconContent = {
    sm: '<path d="M5.308 2 9 5.976V6.5H1v-.524L4.692 2h.616ZM5.308 14 9 10.024V9.5H1v.524L4.692 14h.616Z" />',
};
